import styled from 'styled-components';

export const EyeDropperContainer = styled.div`
  float: right;
  position: relative;
  top: -30px;
  right: 10px;

  > .anticon {
    > #color-picker {
      position: initial !important;
      width: 20px !important;
      height: 18px !important;
      top: initial;
      left: initial;
    }
  }
`;
